/**
 * ## Validate
 *
 *
 * @module src/server/validate
 */

"use strict";

const config = require("../../config/client.js");

/**
 * inspects data shape for validity
 *
 * @param {object} data - data to inspect, must contain _id and domain
 * @returns {object} data - trigger can alter data or leave untouched
 */

const proposed = (data) => {
  if (
    data &&
    data.hasOwnProperty("domain") &&
    config.domains.includes(data.domain)
  ) {
    return { valid: true };
  }
  return { valid: false, errors: "domain property is missing" };
};

const claims = (claims) => {
  const now = Math.floor(new Date().getTime() / 1000);
  if (claims.exp >= now - 60 && claims.authorized) {
    return { valid: true };
  }
  return { valid: false, errors: "Token is expired or unauthorized" };
};

module.exports = {
  proposed,
  claims,
};



/** WEBPACK FOOTER **
 ** ./src/common/validate/index.js
 **/